import {ContentUserProductionDurationDomain} from "../../domain/content/ContentUserProductionDurationDomain"

export const ContentUserProductionDurationDescriptor: Record<keyof ContentUserProductionDurationDomain, (o: ContentUserProductionDurationDomain) => string> = {
    id(o: ContentUserProductionDurationDomain): string {
        return o.id.toString()
    },
    creatorId(o: ContentUserProductionDurationDomain): string {
        return o.creatorId.toString()
    },
    value(o: ContentUserProductionDurationDomain): string {
        return o.value.toString()
    },
    displayOrder(o: ContentUserProductionDurationDomain): string {
        return o.displayOrder.toString()
    },
    createdAt(o: ContentUserProductionDurationDomain): string {
        return o.createdAt.toISOString().substring(0, 19).replace('T', ' ')
    },
    lastModifiedAt(o: ContentUserProductionDurationDomain): string {
        return o.lastModifiedAt?.toISOString().substring(0, 19).replace('T', ' ') ?? '-'
    }
}
